export default {
  getWorkContact(state) {
    return state.work.contact
  }
}
